export default __webpack_public_path__ + "static/media/img_area_95.460ba271.svg";